<template>
  <section>
    <section class="page__title fix text-center">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="page__title-content pt-235">
              <!-- <h2 class="page_title">{{ pageTitle }}</h2> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <h2 class="page_title">{{ pageTitle }}</h2>
  </section>
</template>

<script>
export default {
  props: {
    pageTitle: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss">
.page_title {
  font-size: 40px;
  margin: 60px 0 40px;
}
.page__title {
  margin-bottom: 2rem;
  height: 40rem;
  padding: 0 !important;
  background: url(~@/assets/images/ringtone@3x.png);
  background-size: cover;
  color: #fff;
  background-position: center center;

  @include flex-center;
  h2 {
    font-size: 46px;
  }
}
</style>
